(function (module) {
    'use strict';

    function utils(Store, $window, $state) {
        this.middleClick = ({ $event, model, id, user }) => {
            $event.preventDefault();

            if (user && !user.isAccountAdmin) {
                return;
            }

            const type = _.get($event, 'type');
            const which = _.get($event, 'which');
            const metaKey = _.get($event, 'metaKey');
            const isCmdClick = which === 1 && type === 'mouseup' && metaKey;
            const isMiddleClick = which === 2 && type === 'mouseup';

            if (isCmdClick || isMiddleClick) {
                if (model && id) return $window.open(`/${model}/${id}`, '_blank');
                if (model) return $window.open(`/${model}`, '_blank');
            }
        };

        this.getAccountInfo = (account) => {
            const { agreementSignedDate, trialPeriod } = account;

            const agreementEndDate = moment(agreementSignedDate).clone().add(trialPeriod, 'days').endOf('day').format();
            const trialExpired = moment().isAfter(moment(agreementEndDate));
            const trialLeftString = moment().to(moment(agreementEndDate));
            const trialLeftDays = moment(agreementEndDate).diff(moment(), 'days');

            return {
                ...account,
                trialExpired,
                trialLeftString,
                trialLeftDays,
            };
        };

        this.handleAccountChecks = ({ account, $state }) => {
            const { type, enabled, accountVerified } = account;

            if (!enabled) {
                return $state.go('root.blocked-account');
            }

            if (!accountVerified) {
                return $state.go('unverified-account');
            }

            if (type === 'free') {
                const { trialExpired } = this.getAccountInfo(account);
                if (trialExpired) {
                    return $state.go('root.trial-expired');
                }
            }

            // if we got change via WS, we want to redirect to home
            if (_.get($state, 'current.name') === 'root.trial-expired') return $state.go('root.home');
            if (_.get($state, 'current.name') === 'root.blocked-account') return $state.go('root.home');
        };

        this.handlePermissions = (asset) => {
            const currentUser = Store.getCurrentUser();
            const isAdmin = _.get(currentUser, 'isAccountAdmin', false);

            if (isAdmin) return Promise.resolve(asset);

            const subAccountId = _.get(asset, 'subAccountId', null);
            const permissions = _.values(_.get(currentUser, 'permissions', {}));

            const hasAnyAccess = _.some(permissions);
            const hasAccessSubAccount = _.get(currentUser, `permissions[${subAccountId}]`, false);
            const hasAccessMain = _.get(currentUser, `permissions[main]`, false);

            if (!hasAnyAccess) {
                $state.go('root.no-permissions');
                return Promise.reject();
            }

            if (!hasAccessSubAccount && !hasAccessMain) {
                $state.go('root');
                return Promise.reject();
            }

            return Promise.resolve(asset);
        };
    }

    module.service('utils', utils);
})(angular.module('rocket.components'));
